import { createAsyncThunk } from '@reduxjs/toolkit';
import * as skillService from './ebpc-api';
import type { IRootState } from '../../app/store';

export const getEbpcSkills = createAsyncThunk(
    'ebpc/ebpcSkills',
    async (_, { rejectWithValue, getState }) => {
        try {
            const { isWhitelisted } = (getState() as IRootState)
                .referentialAccess;
            const response = await skillService.getEbpcSkills(isWhitelisted);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
